import GalleryWidget from "./GalleryWidget";
export default GalleryWidget;
